<template>
  <div class="product-list-checkbox">
    <div class="select-all">
      <!-- <el-checkbox @change="change" >全选</el-checkbox> -->
      <el-col :span="12">
        <div class="expressBtn all" :class="{is_active:allSelect}" @click="selectAll()">全部商品</div>
      </el-col>
      <el-col :span="12">
        <div class="expressBtn notAll" :class="{is_active:!allSelect}" @click="notSelectAll()">部分商品</div>
      </el-col>

    </div>
    <ul v-if="order.type == 0">
      <template v-if="curItem.editMode">
        <li class="clearfix">
          <div class="goods_info" style="padding:20px 5px 20px 0;border-bottom: 1px solid #cdcdcd;">
            <div class="goods_info_row">
              <img style="width:100px;height:100px;object-fit: contain;margin-bottom:10px;" :src="curItem.picture" />
            </div>
            <div class="goods_info_row" style="margin-bottom: 10px;position:relative;">
              <el-input placeholder="商品图片网址" v-model="curItem.picture"></el-input>
              <el-upload 
                :action="API_HOST + '/api/order_v2.php?api=upload_picture'"
                :on-success="handleUploadSuccess"
                :headers="headers"
                :before-upload="beforeUpload"
                name="picture"
                style="position:absolute;right:5px;top:10px;">
                <el-button :disabled="isUploading" size="small" type="info">本地上传</el-button>
              </el-upload>
            </div>
            <div class="goods_info_row">                    
              <div class="goods_params">
                <div class="goods_params_row">
                  <div style="display:flex;justify-content: space-between;margin-bottom:10px;">
                    <YueDanIpt style="width:75%;" model="name" :object="curItem" placeholder="商品名称"></YueDanIpt>
                    <YueDanIpt style="width:20%;" model="number" :object="curItem" placeholder="数量"></YueDanIpt>
                  </div>
                  <!--<div class="form_error" v-show="goodError.name || goodError.number" style="position: relative;top: -6px;height:16px;">
                      {{goodError.name?'商品名称是必填项':''}}
                  </div>-->
                  <div style="display:flex;justify-content: space-between;margin-bottom:10px;">
                    <YueDanIpt style="width:65%;" model="color" :object="curItem" placeholder="颜色等"></YueDanIpt>
                    <YueDanIpt style="width:30%;" model="size" :object="curItem" placeholder="尺码等"></YueDanIpt>
                  </div>
                  <!--<div class="form_error" v-show="goodError.price" style="position: relative;top: 2px;height:16px;">
                  </div>-->
                </div>
              </div>
            </div>
            <div class="goods_info_row" style="display: flex;justify-content: space-between;">
              <el-button class="nohover" style="width:48%;height:50px;" @click.stop="cancelGoods">取 消</el-button>
              <el-button style="width:48%;height:50px;" type="info" @click.stop="confirmGoods">保 存</el-button>
            </div>
          </div>
        </li>
      </template>
      <template v-else>
        <li class="clearfix" v-for="(line,index) in groupOrderLine" :key="index">
          <div class="checkbox-container" v-show="!line.editMode">
            <el-checkbox @change="selectLine(line)" v-model="line.checked"></el-checkbox>
          </div>
              <div class="content-container" style="cursor: pointer;" @click="showEdit(line,index)">
                  <div class="clearfix">
                    <div class="img-container">
                      <img v-if="line.picture" :src="line.picture"/>
                      <img  v-else src="https://pic.joyorders.com/blank.png"/>
                    </div>
                    <div class="line-des">
                      <p class="name">{{line.name}}</p>
                      <p>
                        <span v-show="!line.isHideSpecLabel">规格：</span>
                        <span v-html="formatSpecNoLoopUpdate(line.spec,line)"></span>
                      </p>
                      <p v-if="!numEditable"><span>数量：</span>{{line.number}}</p>
                      <el-select @change="changeNum(index,line.selectNum,line.number)" v-if="numEditable" class="inline-block" v-model="line.selectNum" placeholder="">
                        <el-option
                          v-for="item in Number(line.number)"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
              </div>      
        </li>
      </template>
    </ul>
    <ul v-if="order.type==2" class="noBorder">
      <li v-for="(good,index) in goods_info"  class="good_info">
        <el-row >
          <el-col :span="6">
              <!-- <el-upload
              :action="API_HOST + '/api/order.php?api=upload_good_picture'"
              :on-success="handleSuccess"
              :headers="headers"
              :item="good"
              name="good_picture" style="display:inline-block">
              <img v-if="good.image" :src="good.image"/>
              <img v-if="!good.image" src="../../../../ico/uploadpic@2x.png"/>
              </el-upload> -->
              <img v-if="!good.image" src="../../../../ico/uploadpic@2x.png"  @click="showOrderVoucher(index)"/>
              <img v-else :src="good.image"  @click="showOrderVoucher(index)"/>
              <!-- <uploader
              icon="ico ico-uploadpic mt15"
              :item="good"
              :opreation="'发货'"
              :action="API_HOST + '/api/order.php?api=upload_good_picture'"
              v-on:onUploadSuccess="onUploadSuccess"
              ></uploader> -->
          </el-col>
          <el-col :span="18">
            <div>
              <el-input
                type="textarea"
                :rows="2"
                :placeholder="operation=='发货'? '填写已发货商品名称和信息':'填写要取消的商品名称和信息'"
                v-model="good.remark">
              </el-input>
              <div v-if="need_input_price">
                <el-input class="need_input_price" style="width:80%;"
                  placeholder="填写要取消的商品价格"
                  v-model="good.inputPrice">
                </el-input>
                <label>{{order.price_info.goods_price.currency}}</label>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="delete" @click="del(index)">
          <i class="el-icon-delete"></i>
        </div>
      </li>
      <li class="addGoodInfo">
        <div class="addBtn" @click="addGoodInfo()">
          <i class="el-icon-circle-plus-outline"></i><span>继续添加</span>
        </div>
      </li>

    </ul>
  </div>
</template>

<script>
import Uploader from '../../../../components/Uploader'
import YueDanIpt from '../../../../components/YueDanIpt'
import { API_HOST,specOrder,SPEC_MAPPER } from '../../../../services/constant.js'
import {showProductName,formatSpecNoLoopUpdate} from '../../../../services/tools.js'

let _ = require('lodash')

export default {
  name: 'OrderList',
  props: ['groupOrderLine', 'order', 'numEditable', 'operation', 'goods_info','need_input_price'],
  components: {
    Uploader: Uploader,
    YueDanIpt:YueDanIpt
  },
  data () {
    return {
      showProductName:showProductName,
      formatSpecNoLoopUpdate:formatSpecNoLoopUpdate,
      selectNum: 0,
      allSelect: true,
      API_HOST: API_HOST,
      headers: {},
      currentSelectIndex:0,
      curItem:{},
      isUploading:false,
      curIndex:0,
    }
  },
  created () {
    this.headers.token = this.$localStorage.get('token')
    if (this.allSelect) {
      _.each(this.groupOrderLine, line => {
        line.checked = true
      })
      this.$forceUpdate()
    }
    // if(this.order.type == '2'){
    //   this.allSelect = true
    // }else{
    //   this.allSelect = false
    // }
    _.each(this.groupOrderLine, line => {
      this.selectNum = Number(line.number)
      line.selectNum = Number(line.number)
    })
  },
  methods: {
    cancelGoods(){
      this.curItem.editMode=false
      this.$forceUpdate()
    },
    confirmGoods(){
      this.curItem.editMode=false
      let p=JSON.parse(JSON.stringify(this.curItem))
      let obj={}
      let uni= p.unique_param?p.unique_param.replace('_list',''):''
      if(uni)
          obj[uni]=p[uni]
      if(p.vice_param)
          obj[p.vice_param]=p[p.vice_param]
      p.spec=JSON.stringify(obj)
      this.$set(this.groupOrderLine,this.curIndex,p)
      this.$forceUpdate()
    },
    beforeUpload(){
      this.isUploading=true
    },
    handleUploadSuccess: function(response, file, fileList) {
      this.isUploading=false
      if (response.status !== 'ok') {
        this.$message.error('上传失败：'+response.result)
        return;
      }
      this.curItem.picture=response.result
      this.$forceUpdate()
    },
    showEdit(p,index){
      this.curIndex=index
      this.curItem=JSON.parse(JSON.stringify(p))
      this.curItem.editMode=true
      this.$forceUpdate()
    },
    // 跳转到下单凭证
    showOrderVoucher (i) {
      let orderVoucher = document.getElementById('voucher' + this.order.id)
      this.currentSelectIndex = i // d
      this.$emit('showChooseImage', true)
      orderVoucher.click()
    },
    updateGoodInfoImg(res){
      this.goods_info[this.currentSelectIndex].image=res;
    },
    addGoodInfo () {
      this.goods_info.push(
        {image: '', remark: '', id: new Date().getTime()}
      )
      this.$forceUpdate()
    },
    del (index) {
      this.goods_info.splice(index, 1)
    },
    // handleSuccess: function(response, file, fileList) {
    //   console.log(file)
    //   this.isProgressing = false
    //   if (response.status !== 'ok') {
    //     this.$message.error('上传失败：'+response.result)
    //     return;
    //   }

    // },
    onUploadSuccess: function (res) {
      // console.log(res)
      let result = res.response.result
      for (let good of this.goods_info) {
        console.log(good.id, res.item.id)
        if (good.id === res.item.id) {
          good.image = result
          this.$forceUpdate()
          return
        }
      } 
      this.goods_info[this.currentSelectIndex].image = result
      this.$forceUpdate()
    },
    selectAll () {
      this.$emit('changeType', '2')
      if (this.allSelect) {
        return
      }
      this.allSelect = true
      _.each(this.groupOrderLine, line => {
        line.checked = true
        line.selectNum = line.number
        // console.log(line)
      })
      this.$forceUpdate()
    },
    notSelectAll () {
      this.$emit('changeType', '1')
      if (!this.allSelect) {
        return
      }
      if (this.order.type == 0 && this.groupOrderLine && this.groupOrderLine.length === 1 && ~~this.groupOrderLine[0].number === 1) {
        return
      }
      this.allSelect = false
      _.each(this.groupOrderLine, line => {
        line.checked = false
      })
      this.$forceUpdate()
    },
    change (val) {
      _.each(this.groupOrderLine, line => {
        line.checked = val
      })
      this.$forceUpdate()
    },
    changeNum (index, selectNum, max) {
      let flag = false
      _.each(this.groupOrderLine, line => {
        if (!line.checked) {
          flag = true
          // return false
        }
      })
      console.log()
      this.allSelect = !(selectNum < ~~max) && !flag
      this.$forceUpdate()
    },
    selectLine () {
      let flag = false
      _.each(this.groupOrderLine, line => {
        if (line.selectNum < line.number) {
          flag = true
          // return false
        }
        if (!line.checked) {
          flag = true
          return false
        }
      })
      this.allSelect = !flag
      this.$forceUpdate()
      this.$emit('checkNext')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.product-list-checkbox {
  height:100%;
  ul {
    // border-top: 1px solid #CDCDCD;
    //border-bottom: 1px solid #CDCDCD;
    height: calc(100% - 55px);
    margin-top: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    &.noBorder{
      border-bottom:none !important;
    }
    .good_info{
      position: relative;
      border: 1px solid #ccc;
      margin-top: 20px;
      &:first-child{
        margin-top: 0px;
      }
      .delete {
        cursor: pointer;
        position: absolute;
        right: 6px;
        top: 10px;
      }
      img {
        padding: 10px;
        height: 90px;
        width: 90px;
        // -o-object-fit: contain;
        object-fit: contain;
      }
    }
    .addGoodInfo{
      margin-top: 10px;
      .addBtn{
        cursor: pointer;
        display: inline-block;
        i{
          font-size: 16px;
          margin-right: 10px;
        }
      }

    }
    .content-container {
      padding-right: 20px;
      width:100%;
      & > div {
        border-bottom: 1px solid #CDCDCD;
        padding: 20px 0;
        display: flex;
      }

      .inline-block {
        margin-left: 0;
      }
    }

    .img-container {
      width: 100px;
      height: 100px;
      img {
        width: 100px;
        height:100px;
        object-fit: contain;
      }
    }

    li {
      &:last-child {
        .content-container {
          & > div {
            border-bottom: none;
          }
        }
      }
    }
  }

  .line-des {
    margin-left: 15px;
    position: relative;
    top:-6px;
    p {
      line-height: 24px;
      word-break: break-all;
      span {
        color: #888888;
      }
    }
  }
}
.clearfix{
  display: flex;
  justify-content: space-around;
}
.checkbox-container {
  margin-top: 60px;
  width: 30px;
}
.select-all {
  overflow: hidden;
  border-radius: 3px;
  // border: 1px solid #ccc;
  .expressBtn{
    text-align: center;
    display: inline-block;
    border: 1px solid #ccc;
    box-sizing: border-box;
    width: 100%;
    padding: 15px 0;
    cursor: pointer;
    &.is_active{
      background-color: #333;
      border: 1px solid transparent;
      color: #fff;
    }
    &.all {
      border-right: none;
    }
    &.notAll{
      border-left: none;
    }
  }
}
</style>
<style lang="scss">
.product-list-checkbox {
  .select-all {
    .el-checkbox__label {
      color: #888888!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/DaigouProductList.vue